const anchor = $('.has-anchor');
const targets = $('.archon-target');

export function controlAnchors() {
  anchor.on('click', function (event) {
    event.preventDefault();

    let anchorTarget = $(`${$(this).attr('href')}`);

    if (anchorTarget.length) {
      $('html, body').animate({ scrollTop: anchorTarget.offset().top - 20 }, 500);
    }
  });
}

export function trackArchorTarget() {
  let srollCheckpoints = [...targets].map(target => {
    return $(target).offset().top;
  });

  $(window).on('scroll resize', function () {
    let offsets = srollCheckpoints.map(x => window.scrollY - x + 100);
    let positiveOffsets = offsets.filter(x => x > 0);
    let currentAnchorIndex = offsets.indexOf(Math.min(...positiveOffsets));

    currentAnchorIndex = currentAnchorIndex > 0 ? currentAnchorIndex : 0;

    anchor.removeClass('current');
    $(anchor[currentAnchorIndex]).addClass('current');
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchors.js